const serializer = JSON.stringify;
const deserializer = JSON.parse;

JSON.stringify = function (value: any, replacer?: any, space?: any): string {
    const customReplacer = (key: string, value: any) => {
        if (typeof value === "bigint") {
            return `${value}n`;
        }
        return value;
    };

    return serializer(value, replacer || customReplacer, space).replace(
        /"(-?\d+)n"/g,
        "$1",
    );
};

JSON.parse = function (text: string, reviver?: any): any {
    const customReviver = (
        key: string,
        value: any,
        context?: { source: string },
    ) => {
        if (context && context.source) {
            const rawValue = context.source;

            // Check if the raw string represents an integer outside the safe range
            if (Number.isInteger(+rawValue) && !Number.isSafeInteger(+rawValue))
                return BigInt(rawValue);
        }
        return value;
    };

    return deserializer(text, reviver || customReviver);
};
